import $ from 'jquery';

var wwproduct = $(window).width();

if(document.querySelector('.tabProducts') && wwproduct >= 768) {
  document.querySelectorAll('.tabProducts').forEach(element => {
    element.addEventListener('click', (e) => {
      e.preventDefault();
      let $element = e.target;
      let $data = $element.getAttribute('data-id');

      let $eActivA = document.querySelector('.selectproducts a.activeLink');
      if ($eActivA){
        $eActivA.classList.remove('activeLink');
        $eActivA.classList.add('blockLink');
      }

      let $eActiveDiv = document.querySelector('.divproducts div.active');
      if ($eActiveDiv){
        $eActiveDiv.classList.remove('active');
        $eActiveDiv.classList.add('block');
      }

      $element.classList.add('activeLink');
      document.querySelector(`#${$data}`).classList.add('active');
    });
  });
}

if(document.querySelector('#selectEsp') && wwproduct <= 767){

  document.querySelector('#selectEsp').addEventListener('change', (e)=> {
    e.preventDefault();
    
    let $eActiveDiv = document.querySelector('.divproducts div.active');
    if ($eActiveDiv){
      $eActiveDiv.classList.remove('active');
      $eActiveDiv.classList.add('block');
    }

    let $iddata = e.target.value;
    document.querySelector(`#${$iddata}`).classList.add('active');
  });

}
